import BrowserStorageHandler from './BrowserStorageHandler';

export default BrowserStorageHandler;
